"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatters = void 0;
Object.defineProperty(exports, "getBrandValue", {
  enumerable: true,
  get: function get() {
    return _getBrandValue["default"];
  }
});
Object.defineProperty(exports, "getOffersFromDOM", {
  enumerable: true,
  get: function get() {
    return _getOffersFromDOM["default"];
  }
});
Object.defineProperty(exports, "getPageNameValues", {
  enumerable: true,
  get: function get() {
    return _getPageNameValues["default"];
  }
});
Object.defineProperty(exports, "getUserAccountID", {
  enumerable: true,
  get: function get() {
    return _getUserAccountID["default"];
  }
});
Object.defineProperty(exports, "initDataLayer", {
  enumerable: true,
  get: function get() {
    return _initDataLayer["default"];
  }
});
Object.defineProperty(exports, "pushEventToDataLayer", {
  enumerable: true,
  get: function get() {
    return _pushEventToDataLayer["default"];
  }
});
Object.defineProperty(exports, "validateUserAccountID", {
  enumerable: true,
  get: function get() {
    return _validateUserAccountID["default"];
  }
});
var _getBrandValue = _interopRequireDefault(require("./getBrandValue"));
var _getOffersFromDOM = _interopRequireDefault(require("./getOffersFromDOM"));
var _getPageNameValues = _interopRequireDefault(require("./getPageNameValues"));
var _getUserAccountID = _interopRequireDefault(require("./getUserAccountID"));
var _initDataLayer = _interopRequireDefault(require("./initDataLayer"));
var _pushEventToDataLayer = _interopRequireDefault(require("./pushEventToDataLayer"));
var _validateUserAccountID = _interopRequireDefault(require("./validateUserAccountID"));
var _formatters = _interopRequireWildcard(require("./formatters"));
exports.formatters = _formatters;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }